import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	padding: 3em 0 2em 0;

	.boxes {
		display: flex;
		flex-flow: row wrap;
		width: 100%;
		gap: 2em;

		.box {
			width: 30%;
			&:only-of-type {
				width: 100%;
			}
			.box-header {
				font-size: 1em;
				font-weight: 600;
				margin: 0 0 1em 0;
				overflow: hidden;
			}

			.box-content {
				font-size: 1em;
				line-height: 1.4em;
			}
		}

		&.is-even-number {
			.box {
				width: 47%;
			}
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		.boxes {
			flex-flow: column wrap;

			.box {
				width: 100%;
			}
			&.is-even-number {
				.box {
					width: 100%;
				}
			}
		}
	}
`;
